import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const CATEGORIES_ENDPOINTS = {
  V1: createEndpoints('v1', {
    SERVICE_CATEGORIES: (serviceId: string) => `/admin/dynamic-services/${serviceId}/categories`,
    CATEGORY_DETAIL: (categoryId: number) => `/admin/dynamic-services/categories/${categoryId}`,
    CATEGORIES_BULK: (serviceId: string) => `/admin/dynamic-services/${serviceId}/categories/bulk`,
    TERM_DETAIL: (termId: number) => `/admin/dynamic-services/terms/${termId}`,
    INDEXATIONS: '/indexations/',
    INDEXATION_DETAIL: (id: number) => `/admin/indexations/${id}`,
  }),
} as const;
